import React from "react";
import { LoadioAlbumTrackTemplate } from "themes/administration/loadio/components";

class LoadioAlbumTrack extends React.Component {
    render() {
        return <LoadioAlbumTrackTemplate {...this.props} />;
    }
}

export default LoadioAlbumTrack;
